const initialValues = {
  patientId: "",
  chemoOrderForDate: "",
  lineOfTreatment: "",
  chemoTemplate: "",
  regimen: "",
  cycleNo: "",
  week: "",
  day: "",
  diagnosis: [],
  ecogStatus: "",
  toxicity: "",
  sideEffects: "",
  takenOutside: false,
  locationDetails: "",
  investigation: [
    {
      additionalProp1: "",
      additionalProp2: "",
      additionalProp3: "",
    },
  ],
  preMedications: [
    {
      id: "",
      prescriptionId: "",
      medicines: [
        {
          id: "",
          drugId: "",
          type: "",
          medicineName: "",
          dose: "",
          when: "",
          frequency: "",
          duration: "",
          instructions: "",
          selectedSideEffects: [],
          route: "",
        },
      ],
      isCancelled: false,
      readyToSent: false,
      prescriptionDocument: {
        id: "",
        createdAt: "",
        updatedAt: "",
        createdBy: "",
        updatedBy: "",
        name: "",
        blobUrl: "",
        category: "PATIENT",
      },
    },
  ],
  chemotherapyAdministration: [
    {
      type: "",
      medicine: "",
      standardDose: "",
      dose: "",
      doseModification: "",
      notes: "",
      duration: "",
      route: "",
    },
  ],
  takeHomeMedicines: [
    {
      id: "",
      prescriptionId: "",
      medicines: [
        {
          id: "",
          drugId: "",
          type: "",
          medicineName: "",
          dose: "",
          when: "",
          frequency: "",
          duration: "",
          instructions: "",
          selectedSideEffects: [],
          route: "",
        },
      ],
      isCancelled: false,
      readyToSent: false,
      prescriptionDocument: {
        id: "",
        createdAt: "",
        updatedAt: "",
        createdBy: "",
        updatedBy: "",
        name: "",
        blobUrl: "",
        category: "PATIENT",
      },
    },
  ],
  cycleFrequency: "",
  procedureNotes: "",
  clinicalNotes: "",
  followUpDate: "",
  nextCycleOn: "",
  consultantIdForApproval: "",
  testsToBeDone: [
    {
      tests: [
        {
          serviceId: "",
          instructions: "",
          when: "",
        },
      ],
      prescriptionDocument: {
        name: "string",
        blobUrl: "string",
      },
      isSent: false,
      isCancelled: false,
    },
  ],
}

const preMedication = {
  id: "",
  prescriptionId: "",
  sideEffectPreMed: false,
  medicines: [
    {
      id: "",
      drugId: "",
      type: "",
      medicineName: "",
      dose: "",
      when: "",
      frequency: "",
      duration: "",
      instructions: "",
      selectedSideEffects: [],
      route: "",
    },
  ],
  isCancelled: true,
  readyToSent: true,
  prescriptionDocument: {
    id: "",
    createdAt: "",
    updatedAt: "",
    createdBy: "",
    updatedBy: "",
    name: "",
    blobUrl: "",
    category: "PATIENT",
  },
}

const preMedicationMedicine = {
  id: "",
  drugId: "",
  type: "",
  medicineName: "",
  dose: "",
  when: "",
  frequency: "",
  duration: "",
  instructions: "",
  selectedSideEffects: [],
  route: "",
}

const chemotherapy = {
  type: "",
  medicine: "",
  standardDose: "",
  dose: "",
  doseModification: "",
  notes: "",
  duration: "",
  route: "",
}

const takeHomeMedicine = {
  id: "",
  prescriptionId: "",
  sideEffectTakeMed: false,
  medicines: [
    {
      id: "",
      drugId: "",
      type: "",
      medicineName: "",
      dose: "",
      when: "",
      frequency: "",
      duration: "",
      instructions: "",
      selectedSideEffects: [],
      route: "",
    },
  ],
  isCancelled: true,
  readyToSent: true,
  prescriptionDocument: {
    id: "",
    createdAt: "",
    updatedAt: "",
    createdBy: "",
    updatedBy: "",
    name: "",
    blobUrl: "",
    category: "PATIENT",
  },
}

const takeHome = {
  id: "",
  drugId: "",
  type: "",
  medicineName: "",
  dose: "",
  when: "",
  frequency: "",
  duration: "",
  instructions: "",
  selectedSideEffects: [],
  route: "",
}

const testRequired = {
  tests: [
    {
      serviceId: "",
      instructions: "",
      when: "",
    },
  ],
  prescriptionDocument: null,
}

const initialTest = {
  serviceId: "",
  instructions: "",
  when: "",
}

const medicineType = [
  "TAB",
  "INJ",
  "KIT",
  "CAP",
  "SYP",
  "CRM",
  "GEL",
  "DRP",
  "SUS",
  "LIQ",
  "POW",
  "SAC",
  "EXP",
  "OIN",
  "GEN",
  "LOT",
  "GRA",
  "SOAP",
  "SOL",
  "VAC",
  "PAS",
  "INH",
  "OTH",
  "SPR",
]

const DoseType = [
  "1-0-0",
  "0-0-1",
  "1-0-1",
  "1-1-1",
  "1-1-0",
  "0-1-0",
  "0-1-1",
  "0-0-0-1",
]

const whenType = [
  "Before Food",
  "After Food",
  "Before Afternoon",
  "After Breakfast",
  "Before Lunch",
  "After Lunch",
  "Before Dinner",
  "After Dinner",
  "With Food",
  "With Tea",
  "Empty Stomach",
  "Bed Time",
  "Before Bath",
  "After Bath",
  "Before Sun",
  "After Sun",
  "SoS",
]

const frequencyType = [
  "1-0-0",
  "1-0-1",
  "1-1-1",
  "1-1-1-1",
  "1-0-1",
  "1-0-0",
  "1-1-1",
  "1-0-1",
  "1-1-1",
]

export {
  initialValues,
  preMedication,
  chemotherapy,
  takeHomeMedicine,
  testRequired,
  preMedicationMedicine,
  takeHome,
  initialTest,
  whenType,
  DoseType,
  frequencyType,
  medicineType,
}

const values = {
  id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  prescriptionId: "string",
  sideEffectPreMed: true,
  sideEffectTakeHome: true,
  sideEffectChemo: true,
  medicines: [
    {
      id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      drugId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      type: "string",
      medicineName: "string",
      dose: "string",
      doseModification: "string",
      when: "string",
      frequency: "string",
      duration: "string",
      instructions: "string",
      selectedSideEffects: ["string"],
      route: "string",
    },
  ],
  isCancelled: true,
  readyToSent: true,
  prescriptionDocument: {
    id: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
    createdAt: "2023-05-15T11:23:14.157Z",
    updatedAt: "2023-05-15T11:23:14.157Z",
    createdBy: "string",
    updatedBy: "string",
    name: "string",
    blobUrl: "string",
    category: "PATIENT",
  },
}
